import styled from 'styled-components';
import { SectionParent, B1 } from '../../../components/StyledComponents';
import React from 'react';

const Section = styled(SectionParent)`
  background-color: #2a2f46;
  padding: 4rem 18rem;
  padding-bottom: 1rem;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 6rem 14rem;
    padding-bottom: 1rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 4rem 8rem;
    padding-bottom: 1rem;
  }
  @media (max-width: 520px) {
    padding: 2rem;
    padding-bottom: 1rem;
  }
`;

const Content = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.8;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;

export default () => (
  <Section>
    <Content>
      It’s no secret that a key driver of success in the retail industry is
      creating an engaging customer experience. In this increasingly competitive
      marketplace,
      <span style={{ fontWeight: 'bold' }}>
        {' '}
        19 out of 20 top global retail brands are stressing customer experience
        as a key driver for revenue growth.
      </span>{' '}
      The modern retail industry is moving towards an “all digital” ecosystem
      currently driven by digital signage, smart screens, self checkout
      counters, and more resulting in a better customer experience. The
      challenge lies in full performance of these devices round-the-clock. The
      solution? A device management platform that is reliable, scalable and
      secure.
      <br />
      <br />
      The Esper Manage solution is a cloud-based platform for Android devices
      that helps retailers seamlessly build, deploy, and manage retail devices
      with robust support for diagnosing and debugging devices in the field.
    </Content>
  </Section>
);
